var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"featured-content is-hidden-tablet"},[_c('h2',{staticClass:"page-title"},[_vm._v("\n    "+_vm._s(_vm.props.featuredContentHeader)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"columns"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }